import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #aaa;
  text-align: center;
  margin: 25px 0;
  font-weight: 500;
`;

export const DesktopSeparator = styled.div`
  width: 2px;
  height: 20px;
  background-color: rgba(170, 170, 170, 0.3);
  margin: 0 38px;
`;
